// import wx from 'weixin-js-sdk';
import wx from '@tencent/ppd-base-libs/wx/wx-sdk';
import { elk, util } from '@tencent/ppd-base-libs';
const to = util.to;

let initPromise = null;

function reset() {
  initPromise = null;
}

/**
 * jsapi初始化
 * @param  {[type]} wxConfig [description]
 * @return {[type]}          [description]
 */
function init(wxConfig) {
  //单例promise,确保只调用一次
  //如果未初始化过，那就初始化一次，如果已经初始化过，那就等待promise的reject或者resolve状态
  if (!initPromise) {
    initPromise = new Promise((resolve, reject) => {
      const wxConfigInfo = {
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: wxConfig.appId, // 必填，公众号的唯一标识
        timestamp: wxConfig.timestamp, // 必填，生成签名的时间戳，注意这里的参数是timestamp ，小写的s，有些jsapi调用是大写的S
        nonceStr: wxConfig.nonceStr, // 必填，生成签名的随机串
        signature: wxConfig.signature, // 必填，签名
        jsApiList: wxConfig.jsApiList // 必填，需要使用的JS接口列表
      };

      console.log('jsapi init: ', wxConfigInfo);

      const initStartTime = new Date().getTime();

      wx.config(wxConfigInfo);

      let fail = false;
      let isTimeout = false;
      let timeout = null;
      let complete = false;

      //如果失败，wx.err, wx.ready的回调都会执行（从现象来看，是wx.error先执行），所以加一个fail作为flag，如果失败，就不执行resolve
      wx.ready(function() {
        if (isTimeout) {
          return;
        }
        clearTimeout(timeout);
        if (!fail) {
          complete = true;
          //上报ready耗时
          elk({
            key: 'jsapi_init_ready_timecost',
            timeDiff: new Date().getTime() - initStartTime
          });
          resolve(true);
        } else {
          //临时上报代码，后续干掉
          elk({
            key: 'jsapi_ready_but_fail'
          });
        }
      });

      wx.error(function(res) {
        if (isTimeout) {
          return;
        }
        clearTimeout(timeout);
        fail = true;
        complete = true;

        //上报error耗时
        elk({
          key: 'jsapi_init_error_timecost',
          timeDiff: new Date().getTime() - initStartTime
        });

        reject(res.errMsg);
      });

      //超时处理，在浏览器访问会触发
      timeout = setTimeout(() => {
        if (complete) {
          return;
        }
        isTimeout = true;
        reject('jsapi init timeout');
      }, 4000);
    });
  }
  return initPromise;
}

/**
 * 获取初始化promise对象
 * @return {[type]} [description]
 */
function getInitPromiseInstance() {
  if (!initPromise) {
    //后续调用可以不带wxConfig，但是必须有一次init(wxConfig)在最前面
    throw new Error('please invoke init with wxConfig first!');
  }
  return initPromise;
}

/**
 * 拉起支付成功页面
 * @param  {Function} callback [description]
 * @return {[type]}            [description]
 */
async function getH5TransactionRequest(params) {
  //这里不处理jsapi.init的错误，无论jsapi.init成功与否，都去尝试调用下面的jsapi
  await to(getInitPromiseInstance());
  return new Promise((resolve, reject) => {
    wx.invoke('getH5TransactionRequest', params, res => {
      if (/ok/.test(res.err_msg)) {
        resolve(res);
      } else {
        reject(res);
      }
    });
  });
}

/**
 * 拉起app
 * @param  {Function} callback [description]
 * @return {[type]}            [description]
 */
async function launchApplication(params) {
  //这里不处理jsapi.init的错误，无论jsapi.init成功与否，都去尝试调用下面的jsapi
  await to(getInitPromiseInstance());
  return new Promise(resolve => {
    wx.invoke('launchApplication', params, res => {
      resolve(res);
    });
  });
}

/**
 * 获取设备支持的生物识别方式
 * @param  {Function} callback [description]
 * @return {[type]}            [description]
 */
async function getSupportSoter() {
  //这里错了就抛出吧，这样PC上调试可以通过，否则就走不下去了
  //里面的promise reject,这里await就会报错
  await getInitPromiseInstance();
  // 接口调用返回文档 ：http://x.code.oa.com/ppd-web/doc/blob/master/finger_face_pay.md
  return new Promise(resolve => {
    wx.invoke('getSupportSoter', {}, res => {
      resolve(res);
    });
  });
}

/**
 * 请求SOTER生物认证
 * @param  {[type]} params [description]
 * @return {[type]}        [description]
 */
async function requireSoterBiometricAuthentication(params) {
  //这里错了就抛出吧，这样PC上调试可以通过，否则就走不下去了
  //里面的promise reject,这里await就会报错
  await getInitPromiseInstance();
  const data = {
    auth_mode: params.auth_mode,
    challenge: params.challenge
  };
  // 接口调用返回文档 ：http://x.code.oa.com/ppd-web/doc/blob/master/finger_face_pay.md
  return new Promise(resolve => {
    wx.invoke('requireSoterBiometricAuthentication', data, res => {
      resolve(res);
    });
  });
}

/**
 * 隐藏所有非基础按钮
 * @param  {Function} callback [description]
 * @return {[type]}            [description]
 */
async function hideAllNonBaseMenuItem() {
  //这里不处理jsapi.init的错误，无论jsapi.init成功与否，都去尝试调用下面的jsapi
  await to(getInitPromiseInstance());
  return new Promise(resolve => {
    wx.invoke('hideAllNonBaseMenuItem', {}, res => {
      resolve(res);
    });
  });
}

/**
 * 隐藏底部导航栏
 * @param  {Function} callback [description]
 * @return {[type]}            [description]
 */
async function hideToolbar() {
  //这里不处理jsapi.init的错误，无论jsapi.init成功与否，都去尝试调用下面的jsapi
  await to(getInitPromiseInstance());
  return new Promise(resolve => {
    wx.invoke('hideToolbar', {}, res => {
      resolve(res);
    });
  });
}

/**
 * 隐藏网页右上角按钮
 * @param  {Function} callback [description]
 * @return {[type]}            [description]
 */
async function hideOptionMenu() {
  //这里不处理jsapi.init的错误，无论jsapi.init成功与否，都去尝试调用下面的jsapi
  await to(getInitPromiseInstance());
  return new Promise(resolve => {
    wx.invoke('hideOptionMenu', {}, res => {
      resolve(res);
    });
  });
}

/**
 * 关闭当前webview
 * @param  {Function} callback [description]
 * @return {[type]}            [description]
 */
async function closeWindow(param = {}) {
  //这里不处理jsapi.init的错误，无论jsapi.init成功与否，都去尝试调用下面的jsapi
  //await to(getInitPromiseInstance());

  return new Promise(resolve => {
    wx.invoke('closeWindow', param, res => {
      resolve(res);
    });
  });
}

/**
 * 增加自定义menu
 * @param  {Function} callback [description]
 * @return {[type]}            [description]
 */
async function addCustomMenuItems(params) {
  //这里不处理jsapi.init的错误，无论jsapi.init成功与否，都去尝试调用下面的jsapi
  await to(getInitPromiseInstance());
  return new Promise(resolve => {
    wx.invoke('addCustomMenuItems', params, res => {
      resolve(res);
    });
  });
}

/**
 * 通过open-ssh生成客户端公私钥
 * fetch就是取，如果没有
 * @param   {[type]}  type          [save | fetch]
 * @param   {[type]}  walletRegion  [walletRegion description]
 * @return  {[type]}                [return description]
 */
async function handleWCPayWalletBuffer(options) {
  //这里不处理jsapi.init的错误，无论jsapi.init成功与否，都去尝试调用下面的jsapi
  await to(getInitPromiseInstance());
  const { type, privateKey, publicKey, walletRegion, wxConfigInfo } = options;
  const { appId, signType, paySign, nonceStr } = wxConfigInfo;

  console.log(
    `jsapi index handleWCPayWalletBuffer: type, privateKey, publicKey, walletRegion , ${JSON.stringify(
      options
    )}`
  );
  //let walletRegion = params.walletRegion || '8';
  const data = {
    appId,
    signType,
    timeStamp: wxConfigInfo.timestamp, //注意这里的参数是timeStamp ， 大写的S 。 wx.config中的是小写的s
    package: wxConfigInfo.package,
    paySign,
    nonceStr,
    action: type || 'fetch',
    walletRegion
  };

  if ('save' === type) {
    data.buffer = `${privateKey}^${publicKey}`;
  }

  return new Promise((resolve, reject) => {
    wx.invoke('handleWCPayWalletBuffer', data, res => {
      console.log(
        `handleWCPayWalletBuffer  param: ${JSON.stringify(
          data
        )}, res: ${JSON.stringify(res)}`
      );

      //下面是一个具体调用fetch的实例：
      //handleWCPayWalletBuffer  param: {"appId":"wx8d9c8a87488fa38a","signType":"SHA1","timeStamp":"1561546072","package":"qrpay_index","paySign":"2be4cb7e9d3c18f7786433f94dcd525407627ec9","nonceStr":"d41d8cd98f00b204e9800998ecf8427e","action":"fetch","walletRegion":"8","verifyAppId":"wx8d9c8a87488fa38a","verifySignType":"sha1","verifyTimestamp":"1561546072","verifyNonceStr":"d41d8cd98f00b204e9800998ecf8427e","verifySignature":"f246c5a4a8688a133188be705e63d3b4e7593dcf","__context_key":"46505975be7ffa24add0608c7bb9cee8ca12d178"},
      //res: {"err_msg":"handleWCPayWalletBuffer:ok","buffer":"-----BEGIN RSA PRIVATE KEY-----\nMIICXQIBAAKBgQCGPD6htrEzRqrACCCun1LSFvc4Ae8exk4xnTwhhRrN+Sqvn2ga\nEB2rh59JdQ0JaOgLw514SN2jp/vRA8PTwt/rtklkZf1WKmuqdKfVM30qnHzR7qc+\nY9MVTkUfgPja9MmYKKU6OqAHwrp7qbYliftHmPryhCBW3n4kQfarreryFwIDAQAB\nAoGAXp5Ke4yeHQmbxB42gz/0jff4LHdYiLW5Wkl9oBcFjNgsGXzgUTa44zaGta2X\nEeHrZpdtAONDr17yJiNkPnjngl6rHPkGoNnx3CdFNJnZQgsi0rp/1kYyNxqFyaCc\nHLBvbvYyfB2IIgH4Y04WxsiX/dvQQgmsXPI9kL+prMkf2HkCQQDrll7PQBdtwjG8\nEdLkiBAzG4+hz7T5STiEsq2Pi8n97om4KHKrkxHbpak5siJmCM/MJuZtaALCMOgx\nRxu7sqlrAkEAkd3BjWMTiqTcPRYtwsN+hrleHL9qN1BLGM19yJXAgD1redbhdfH6\n/rQZy7P8I6CA2zsJFHkxnCbp5ZGeLEKpBQJBAIQKl8EZbwg5m56JbuZfzJSYkfxj\nak9+VospilW2R9RnahEpununxo6RXzPTP6xoq+8ErooLjeBBgSJ9dHHTRVkCQB26\nkZEsaTYvpYd5trfkOixhKVI4nQBLCBM1BnbUNpisa/Q4HFl6iQpSUJOYykHEm56S\n6KXYkYje0Xrtc8xXhbUCQQDp1t5DLzR5WLNT5qoC2CB1WizRwp32/XCtRHPuyvsL\nDvSAyFsEMd9Rqxuvck4XuVpMB8L4rCXwYlnmcYVTc3Qw\n-----END RSA PRIVATE KEY-----^-----BEGIN PUBLIC KEY-----\nMIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCGPD6htrEzRqrACCCun1LSFvc4\nAe8exk4xnTwhhRrN+Sqvn2gaEB2rh59JdQ0JaOgLw514SN2jp/vRA8PTwt/rtklk\nZf1WKmuqdKfVM30qnHzR7qc+Y9MVTkUfgPja9MmYKKU6OqAHwrp7qbYliftHmPry\nhCBW3n4kQfarreryFwIDAQAB\n-----END PUBLIC KEY-----"}
      if (/ok/.test(res.err_msg)) {
        let certInfo = null;
        //fetch的时候，才会返回buffer
        if ('fetch' === type) {
          const info = res.buffer.split('^');
          certInfo = {
            privateKey: info[0],
            publicKey: info[1]
          };
        }
        resolve(certInfo);
      } else {
        reject(res);
      }
    });
  });
}

async function getH5PrepayRequest(params) {
  //这里不处理jsapi.init的错误，无论jsapi.init成功与否，都去尝试调用下面的jsapi
  await to(getInitPromiseInstance());
  console.log('getH5PrepayRequest: ', 'before invoke');
  return new Promise(resolve => {
    wx.invoke('getH5PrepayRequest', params, res => {
      console.log('getH5PrepayRequest: ', 'after invoke',res);
      resolve(res);
    });
  });
}

export default {
  reset,
  init,
  getInitPromiseInstance,
  getSupportSoter,
  requireSoterBiometricAuthentication,
  getH5TransactionRequest,
  hideAllNonBaseMenuItem,
  hideToolbar,
  hideOptionMenu,
  closeWindow,
  launchApplication,
  addCustomMenuItems,
  handleWCPayWalletBuffer,
  getH5PrepayRequest
};
